import { Injectable } from '@angular/core';
import { ClientListDto } from '@common/generated-api/models/client-list-dto';
import { AdminClientsApiService } from '@common/generated-api/services/admin-clients-api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private adminClientsApiService: AdminClientsApiService) {}

  searchClients(query: string, limit: number, distributorId?: number): Observable<ClientListDto[]> {
    return this.adminClientsApiService
      .searchClients({
        body: {
          searchText: query,
          limit,
          distributor: distributorId,
          offset: 0,
          sorting: [{ order: 'ASC', type: 'NAME' }],
        },
      })
      .pipe(
        map((data) => data.result.data),
        catchError(() => of([])),
      );
  }

  getClient(clientId: number) {
    return this.adminClientsApiService.getClient({ clientId }).pipe(map((data) => data.result));
  }
}
